import { BMButton, BMPopup, BMText } from "@traveloka/district-bloom";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../../utils";
import { CHILD_DEFAULT_AGE } from "./constants";

type Props = {
  isVisible: boolean;
  onCancel: () => void;
  onContinue: () => void;
};

export default function ChildAgePopup(props: Props) {
  const { isVisible, onCancel, onContinue } = props;
  const { CorporateHotelSearchForm: cr } = useMobileContentResource();
  return (
    <BMPopup
      withCloseButton
      FooterComponent={
        <BMView>
          <BMButton
            size="LARGE"
            stretchable
            label={cr.continue}
            onPress={onContinue}
          />
        </BMView>
      }
      isVisible={isVisible}
      onPopupClose={onCancel}
      title={cr.nonEmployeeChildPopupTitle}
    >
      <BMText ink="BMStyleTextInkPrimary" variant="paragraphNormal">
        {formatMessage(cr.nonEmployeeChildPopupSubTitle, {
          defaultAge: CHILD_DEFAULT_AGE,
        })}
      </BMText>
    </BMPopup>
  );
}
